/** Intraday/Positional tab choice on the Strategies page (operator
 * request 2026-07-26: divide the horizons "in UI" — as tabs, like the
 * Market page). The last choice is remembered; storage access is
 * defensive for private-mode browsers and the test DOM. */

export type HorizonTab = "intraday" | "positional";

const TAB_STORAGE_KEY = "nss-strategies-tab";

export function readStoredHorizonTab(): HorizonTab {
  try {
    return window.localStorage.getItem(TAB_STORAGE_KEY) === "positional"
      ? "positional"
      : "intraday";
  } catch {
    return "intraday";
  }
}

export function storeHorizonTab(tab: HorizonTab): void {
  try {
    window.localStorage.setItem(TAB_STORAGE_KEY, tab);
  } catch {
    // Private mode / no storage — the choice just isn't remembered.
  }
}
